import englishData from '../data/en/data';
  
export default data =>{
    return englishData;
};
